const booleanLiteral = {
    true: 'True',
    false: 'False'
};

export default booleanLiteral;
